import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { ConceptCard } from '@app/components/blocks/card/ConceptCard'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'
import { useQuery } from '@based/sdk/react'

type Concept = ServiceProviderViewModel['serviceProvidersConcepts'][number]

const ConceptCardItem = ({ concept }: { concept: Concept }) => {
  const followerCountQuery = useQuery('count-followers', {
    entityType: 'serviceProviderConcept',
    entityIds: [concept.id],
  })

  return (
    <ConceptCard
      image={concept.banner?.src}
      title={concept.name}
      description={concept.intro}
      followers={concept.followers}
      followerCount={followerCountQuery.data?.[0] ?? 0}
      slug={concept.slug}
    />
  )
}

export const Concepts = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const translations = useTranslations().app

  return (
    <Column>
      <Title.H4>{translations.serviceProviderPage.ourConcepts}</Title.H4>
      {serviceProvider.serviceProvidersConcepts &&
        serviceProvider.serviceProvidersConcepts.map((concept) => (
          <ConceptCardItem key={concept.id} concept={concept} />
        ))}
    </Column>
  )
}
